enum VocabularyKind {
  PERSON = 'PERSON',
  THEME = 'THEME',
  DISTRICT = 'DISTRICT',
  CLASSIFICATION = 'CLASSIFICATION',
  CLOCK_DRIVE = 'CLOCK_DRIVE',
  ICONCLASS = 'ICONCLASS',
  MATERIAL = 'MATERIAL',
  TECHNIQUE = 'TECHNIQUE',
  COIN_MINT = 'COIN_MINT',
  COIN_TERRITORY = 'COIN_TERRITORY',
}

export default VocabularyKind;
